import { useState, useEffect } from 'react'

import { slsClient } from '../clients/slsClient'
import { medicareApiClient } from '../clients/medicareApiClient'

import User from '../models/User'

export const useMedicareAuthFlow = () => {
  const [user, setUser] = useState<User | undefined>(undefined)

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { req_token: slsRequestToken } = await slsClient.getReqToken()

        if (slsRequestToken) {
          // Set temporary first name value until full user data is returned
          setUser({ firstName: '...' } as User)
          const response: User = await medicareApiClient.getBeneficiaryByReqToken(slsRequestToken)
          setUser(response)
        }
      } catch (error) {
        console.error(error)
        // If a sls request token was retrieved and medicare api did not return a user, unset the temp user
        setUser(undefined)
        // alert('There was an error fetching the beneficiary')
      }
    }

    fetchUser()
  }, [])

  return user
}
